import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { FieldIssue } from 'api/crm/intakeFormAPI';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useFormikContext } from 'formik';
import { DISABLED_FORM_STATUS } from 'constants/form';

// components
import DivAlignCenter from 'components/Additional/DivAlignCenter';
import LeaveCommentForm from './LeaveCommentForm';
import { IconSVG, Text } from '@ui';
import { ReactComponent as AlertIcon } from 'resources/icons/remix-icons/alert-fill.svg';
import { ReactComponent as CheckIcon } from 'resources/icons/remix-icons/checkbox-circle-fill.svg';

interface IProps {
  fieldIssue: FieldIssue;
  isResolved: boolean;
}

const PopoverContent = ({ isResolved, fieldIssue }: IProps) => {
  const { t } = useTranslation('onboarding');
  const { status } = useFormikContext();

  return (
    <Content>
      <DivAlignCenter>
        {isResolved ? (
          <ResolvedWrapper>
            <StyledIconSVG
              component={CheckIcon}
              color={colorsTheme.colorPrimary}
            />
            {t('intake_form.review_field_issues.resolved')}
          </ResolvedWrapper>
        ) : status === DISABLED_FORM_STATUS ? (
          <ResolvedWrapper>
            <StyledIconSVG
              component={AlertIcon}
              color={colorsTheme.colorWarning}
            />
            {t('intake_form.review_field_issues.not_resolved')}
          </ResolvedWrapper>
        ) : null}
      </DivAlignCenter>
      <Text color={colorsTheme.colorWhite} weight="semi-bold">
        {t('intake_form.review_field_issues.comment')}
      </Text>
      <Text>{fieldIssue.comment}</Text>
      <LeaveCommentForm
        disabled={status === DISABLED_FORM_STATUS}
        fieldIssue={fieldIssue}
      />
    </Content>
  );
};

const Content = styled.div`
  width: 450px;
`;

const ResolvedWrapper = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledIconSVG = styled(IconSVG)`
  margin-right: ${({ theme }) => theme.marginXs};
`;

export default PopoverContent;
